// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__zC3Qi","content":"styles_content__3lSZ8","selectAll":"styles_selectAll__2e1HS"};